import { render, staticRenderFns } from "./weButton.vue?vue&type=template&id=cbeb3baa&scoped=true"
import script from "./weButton.vue?vue&type=script&lang=js"
export * from "./weButton.vue?vue&type=script&lang=js"
import style0 from "./weButton.vue?vue&type=style&index=0&id=cbeb3baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbeb3baa",
  null
  
)

export default component.exports